import { render, staticRenderFns } from "./authGroup.vue?vue&type=template&id=04e38fce&scoped=true&"
import script from "./authGroup.vue?vue&type=script&lang=js&"
export * from "./authGroup.vue?vue&type=script&lang=js&"
import style0 from "./authGroup.vue?vue&type=style&index=0&id=04e38fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e38fce",
  null
  
)

export default component.exports